/**
 * Возвращает день недели `weekday`, часы `hours` и минуты `minutes` из строки `value`.
 * Строка должна быть в формате "День недели ЧЧ:ММ". Так же возвращает флаг валидности,
 * если не удалось извлечь часы и минуты, и день недели, если установлен флаг
 * обязательности дня недели `weekdayRequired`.
 */
export const getInputTimeParts = (value: string, weekdayRequired: boolean) => {
  const regex = /^(?:(\p{L}+)\s)?(\d{2}):(\d{2})$/u
  const match = value.match(regex)
  if (!match) return { weekday: null, hours: null, minutes: null, valid: false }

  const weekday = match[1] || null
  const hours = match[2]
  const minutes = match[3]

  return {
    weekday,
    hours,
    minutes,
    valid: weekdayRequired ? !!weekday && !!hours && !!minutes : !!hours && !!minutes,
  }
}
